import React from "react";

import ImportExportMenu from "Components/Common/DataImport/ImportExportMenu";
import { DataImportConfig } from "Components/Common/DataImport/dataImportFields";
import {
  exportLTAServicesToCSV,
  importLTAService,
} from "common/services/ltas.service";

const importConfig: DataImportConfig = {
  title: "LTA Services",
  entityLabel: "LTA service",
  icon: "ri-service-line",
  templateFile: "lta_services_import_template.csv",
  importFn: importLTAService,
  fields: [
    {
      key: "name",
      label: "Name",
      required: true,
      hint: "Must be unique across LTA services",
    },
    { key: "description", label: "Description" },
  ],
};

/** Import/export menu for the LTA services table. */
const Import = ({ apiParams }: { apiParams?: any }) => (
  <ImportExportMenu
    resource="lta-service"
    config={importConfig}
    exportFn={exportLTAServicesToCSV}
    exportFileName="LTA_Services_Export.csv"
    apiParams={apiParams}
  />
);

export default Import;
